import moduleName from './module';

export default moduleName;



// WEBPACK FOOTER //
// ./src/index.js